import React from 'react'
import { connect } from "react-redux";
import { SetDepositOldBank } from '$Deposits/store/actions/DepositAction'
import { SetDepositPayments_QD } from '$Deposits/store/actions/DepositPost'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import { QD_Submit } from '$Deposits/store/actions/DepositEvent'



class QD extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            DepositNextStep,
            DepositSuccessPage,
            DepositOldBank,
            SetDepositOldBank,
            TipsView,
            MoneyInput,
            BankSelect,
            SubmitBtn,
            NextStep,
            SuccessPage,
            OldBank,
            OldBankLine,
            UserBankSelect,
            BanksBankAccounts,
            BankNone,
            SetDepositPayments_QD,
        } = this.props
        let { isAutoAssign } = this.props.DepositBankActive

        return (
            <>
                {
                    (isAutoAssign && !DepositNextStep && !DepositSuccessPage && !DepositOldBank)
                        ?
                        <>
                            <TipsView msg={`Để lệnh gửi tiền được cập nhật nhanh chóng,  vui lòng chuyển khoản đúng số tiền mà hệ thống cung cấp ngược lại cho Bạn ở bước “Tiếp Theo”`} />
                            <MoneyInput />
                            <UserBankSelect />
                            {/* <OldBankLine
                                onChange={() => { SetDepositOldBank(true) }}
                                msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                            /> */}
                            <SubmitBtn
                                OldBankLine={<OldBankLine
                                    onChange={() => { SetDepositOldBank(true) }}
                                    msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                                />}
                                submitBtn={QD_Submit}
                                onPress={() => { SetDepositPayments_QD() }}
                                submitBtnItem={'Tiếp Theo'}
                            />
                        </>
                        :
                        <>
                            {
                                //没有银行卡
                                !DepositNextStep && !DepositSuccessPage && !DepositOldBank && BanksBankAccounts.length == 0 &&
                                <>
                                    <BankNone LivechatClick={LivechatClick} methods={'QD'} onChange={() => { SetDepositOldBank(true) }} />
                                </>
                            }

                            {
                                BanksBankAccounts.length > 0 &&
                                <>
                                    {
                                        !DepositNextStep && !DepositSuccessPage && !DepositOldBank &&
                                        <>
                                            <TipsView msg={`Để lệnh gửi tiền được cập nhật nhanh chóng,  vui lòng chuyển khoản đúng số tiền mà hệ thống cung cấp ngược lại cho Bạn ở bước “Tiếp Theo”`} />
                                            <MoneyInput />
                                            <BankSelect />
                                            <UserBankSelect />
                                            {/* <OldBankLine
                                                onChange={() => { SetDepositOldBank(true) }}
                                                msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                                            /> */}
                                            <SubmitBtn
                                                OldBankLine={<OldBankLine
                                                    onChange={() => { SetDepositOldBank(true) }}
                                                    msg={'Tôi đã gửi tiền vào tài khoản cũ'}
                                                />}
                                                submitBtn={QD_Submit}
                                                onPress={() => { SetDepositPayments_QD() }}
                                                submitBtnItem={'Tiếp Theo'}
                                            />
                                        </>
                                    }
                                </>
                            }
                        </>
                }


                {
                    //下一步
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    //存款成功
                    DepositSuccessPage &&
                    <SuccessPage />
                }
                {
                    DepositOldBank &&
                    <OldBank />
                }
            </>

        );
    }
}

const mapStateToProps = state => ({
    BanksBankAccounts: state.BanksBankAccounts,
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositOldBank: state.DepositOldBank,
    DepositBankActive: state.DepositBankActive,
});
const mapDispatchToProps = {
    SetDepositOldBank: (data = false) => SetDepositOldBank(data),
    SetDepositPayments_QD: (data = {}) => SetDepositPayments_QD(data)
};
export default connect(mapStateToProps, mapDispatchToProps)(QD);